
document.addEventListener("click", function(e) {
  // Open popup
  if (e.target.closest("#openPopup")) {
    document.getElementById("popupOverlay").style.display = "block";
  }

  // Close popup
  if (e.target.closest("#closePopup") || e.target.id === "popupOverlay") {
    document.getElementById("popupOverlay").style.display = "none";
  }
});


//Changes for copy coupan popup
document.addEventListener("DOMContentLoaded", function () {
  const banners = document.querySelectorAll(".coupon-text");
  const notification = document.getElementById("copyNotification");

  banners.forEach((banner) => {
    banner.addEventListener("click", () => {
      const coupon = banner.getAttribute("data-coupon");

      navigator.clipboard.writeText(coupon).then(() => {
        notification.classList.add("show");
        setTimeout(() => {
          notification.classList.remove("show");
        }, 2000); // Hide after 2 seconds
      }).catch(err => {
        console.error("Failed to copy coupon:", err);
      });
    });
  });
});


